<template>
  <div style="display: inline;font-size: 14px">
<!--    <el-button size="mini" :type="firstButon.icon === 'el-icon-success' || firstButon.icon === 'el-icon-error' ? 'danger' : 'success'" :underline="false" :icon="firstButon.icon" style="margin-left: 10px;margin-right: 10px;" @click="handleCommand(firstButon.index)">{{firstButon.name}}-->
<!--    </el-button>-->
    <el-dropdown class="td_dropdown" trigger="click" size="mini" split-button type="primary" @click="handleCommand(firstButon.index)" @command="handleCommand">
      {{firstButon.name}}
<!--      <span class="el-dropdown-link">-->
<!--        <i class="el-icon-arrow-down"></i>-->
<!--      </span>-->
      <el-dropdown-menu slot="dropdown">
        <div v-for="(item,index) in moreButton" :key="index">
          <el-dropdown-item style="color: #F56C6C;padding: 0 0;margin: 0 15px 0 15px" :icon="item.icon" :command="item.index" :title="item.title" v-if="item.check" >{{item.name}}</el-dropdown-item>
        </div>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'd2-container-more-button',
  computed: {
    ...mapGetters(['permissions'])
  },
  props: {
    moreButton: {
      type: Array,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      firstButon: {}
    }
  },
  methods: {
    handleCommand (command) {
      // this.moreButton.forEach((item, index) => {
      //   item.check = true
      //   item.index = index
      // })
      // this.firstButon = this.moreButton[command]
      // this.moreButton[command].check = false
      this.$emit('onClick', this.moreButton[command])
    },
    createFirstMenu () {
      this.moreButton.forEach((item, index) => {
        item.index = index
      })
      this.firstButon = this.moreButton[0]
      this.moreButton[0].check = false
    }
  },
  created () {
    this.createFirstMenu()
  }
}
</script>

<style lang="scss">
.el-icon-arrow-down:hover {
  color:#3A6FCF;
}
.td_dropdown .el-button {
  height: 28.5px;
}
.el-button--primary {
  background: #3A6FCF;
  border-color: #3A6FCF;
  color: #FFF;
}
.el-button--primary:focus, .el-button--primary:hover {
  background: #5e86ce;
  border-color: #5e86ce;
  color: #FFF;
}
.el-button--danger {
  background: #FC4958;
  border-color: #FC4958;
  color: #FFF;
}
.el-button--danger:focus, .el-button--danger:hover {
  background: #ff6774;
  border-color: #ff6774;
  color: #FFF;
}
.el-button--warning {
  background: #FF972F;
  border-color: #FF972F;
  color: #FFF;
}
.el-button--warning:focus, .el-button--warning:hover {
  background: #fdaf61;
  border-color: #fdaf61;
  color: #FFF;
}
</style>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/components/d2-container-more-button/index.vue"
}
</vue-filename-injector>
